export default __webpack_public_path__ + "static/media/slider-img17.d874e8b9.jpg";